/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax);


// axios
import axios from "./axios.js"
Vue.prototype.$http = axios;

Vue.prototype.$printError = function (error) {

    if(error.length === 0) return;

    this.$vs.notify({
        title:'Error',
        text: error,
        color:'danger',
        iconPack: 'feather',
        icon:'icon-alert-circle'})
};

Vue.prototype.$printSuccess = function (message) {
    this.$vs.notify({
        title:'Success',
        text: message,
        color:'success',
        iconPack: 'feather',
        icon:'icon-check-circle'})
};

// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'

//Moment.js
import moment from 'moment-timezone'
Vue.prototype.moment = moment;

// Vuex Store
import store from './store/store'

// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);

// i18n
import i18n from './i18n/i18n'

// Vuexy Admin Filters
import './filters/filters'

// VeeValidate
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer);

/*import { ApmVuePlugin } from '@elastic/apm-rum-vue'
Vue.use(ApmVuePlugin, {
    router,
    config: {
        serviceName: "SkynetAPI_Staging",
        serverUrl: "https://apm.rmk.network:443"
    }
});*/

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css');

Vue.prototype.$checkPermission = (permission) => {
    if(permission){
        if(store.getters.permissions.includes(permission)){
            return true
        }
        return false
    }
    return true
};

Vue.prototype.$calculateTextArea = (text) => {
    return (((text.split(/\r\n|\r|\n/).length + 1) > 4 ) ? (text.split(/\r\n|\r|\n/).length + 1) * 20 : 100) + 'px';
};

Vue.config.productionTip = false;

axios.get('/api/v1/ping/').then(function (response) {
    store.dispatch('setLoginStatus', true);
    if(response.data) store.dispatch('setDevelopment');
    loadVue();
}).catch(function () {
    store.dispatch('setLoginStatus', false);
    loadVue();
});

function loadVue() {

    if (localStorage.getItem("language") !== null) {
        store.commit('SET_LANGUAGE', localStorage.getItem("language"));
    }

    if (localStorage.getItem("hiddenTasksColumns") !== null) {
        store.commit('SET_HIDDEN_TASKS_COLUMNS', JSON.parse(localStorage.getItem("hiddenTasksColumns")));
    }

    if (localStorage.getItem("hiddenProjectsColumns") !== null) {
        store.commit('SET_HIDDEN_PROJECTS_COLUMNS', JSON.parse(localStorage.getItem("hiddenProjectsColumns")));
    }

    if (localStorage.getItem("deselectedTaskTags") !== null) {
        store.commit('SET_DESELECTED_TASK_TAGS', JSON.parse(localStorage.getItem("deselectedTaskTags")));
    }

    if (localStorage.getItem("navMenuCollapsed") !== null) {
        store.commit('TOGGLE_REDUCE_BUTTON', JSON.parse(localStorage.getItem("navMenuCollapsed")));
    }

    axios.interceptors.response.use(function (response) {
        return response
    }, function (error) {
        if (error.response.status === 401) {
            store.dispatch('setLoginStatus', false);
            document.body.style.zoom = "100%";
            router.push('/login')
        }
        if (error.response.status === 403) {
            router.push('/tasks/own')
        }
        return Promise.reject(error)
    });

    new Vue({
        router,
        store,
        i18n,
        render: h => h(App)
    }).$mount('#app');
}


